import AsoHeader from "../../../components/Aso/Header";
import AsoVerificarCadastroEmpresa from "../../../components/Aso/Register/AsoVerificarCadastroEmpresa";

const VerificarCadastroEmpresa = () => {
    return(
        <>
            <AsoHeader />
            <AsoVerificarCadastroEmpresa />
        </>
    );
}

export default VerificarCadastroEmpresa;